import Link from '@material-ui/core/Link';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasValue, loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'modules/DocumentUploadList');
const layout = window?.$environment?.CURRENT_LAYOUT;
const Upload = lazy(() => import(`@/modules/DocumentUpload`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`);

const List = ({
  list,
  saveDocument,
  deleteDocument,
  apiStatus,
  callback,
  userId,
  trailerIdPub,
  vehicleIdPub,
  isEdit,
  downloadDocument,
  logBook,
  viewOnly,
}) => {
  const { i18n } = useTranslation();
  const [currentItem, setCurrentItem] = useState({});
  const [open, setOpen] = useState(false);

  const uploadApi = 'uploadApi';
  const deleteApi = 'deleteApi';

  const hasDocumentDeleteApi = hasValue(apiStatus?.status, 'api', deleteApi);
  const hasUploadApi = hasValue(apiStatus?.status, 'api', uploadApi);

  const closeModal = () => {
    setOpen(false);
  };

  const clickedModal = () => {
    setOpen(true);
  };

  return (
    <Styled.Wrapper>
      {hasDocumentDeleteApi?.errorMessage && <Message type="error" message={i18n.t(hasDocumentDeleteApi.errorMessage)} />}
      {hasUploadApi?.errorMessage && <Message type="error" message={i18n.t(hasUploadApi.errorMessage)} />}
      <iframe title="downloadDocumentFrame" id="downloadDocumentFrame" style={{ display: 'none' }}></iframe>
      {list.map((item, i) => {
        return (
          <Row
            key={i}
            item={item}
            openModal={clickedModal}
            deleteDocument={deleteDocument}
            setCurrentItem={setCurrentItem}
            userId={userId}
            trailerIdPub={trailerIdPub}
            vehicleIdPub={vehicleIdPub}
            isEdit={isEdit}
            downloadDocument={downloadDocument}
            logBook={logBook}
            viewOnly={viewOnly}
          />
        );
      })}
      {open && (
        <Modal.default
          open={open}
          setOpen={setOpen}
          data={{
            header: '',
            content: () => {
              return (
                <Upload
                  closeModal={closeModal}
                  saveDocument={saveDocument}
                  currentItem={currentItem}
                  uploadApi={uploadApi}
                  callback={callback}
                  userId={userId}
                  trailerIdPub={trailerIdPub}
                  vehicleIdPub={vehicleIdPub}
                  isEdit={isEdit}
                />
              );
            },
          }}
          onCloseModal={closeModal}
          background="black"
          withCloseIcon
        />
      )}
    </Styled.Wrapper>
  );
};

export default List;

List.propTypes = {
  apiStatus: PropTypes.object,
  callback: PropTypes.func.isRequired,
};

const Row = ({
  item,
  openModal,
  deleteDocument,
  setCurrentItem,
  userId,
  trailerIdPub,
  vehicleIdPub,
  isEdit,
  downloadDocument,
  viewOnly,
}) => {
  const { i18n } = useTranslation();
  const deleteApi = 'deleteApi';

  return (
    <>
      {(!viewOnly || (viewOnly && item.id)) && (
        <li>
          <>
            {!viewOnly && (
              <Icon
                onClick={() => {
                  setCurrentItem(item);
                  openModal();
                }}
                className="imageUploadsection"
                src={item.id ? mediaUrls?.refreshIcon : mediaUrls?.uploadIcon}
              />
            )}
            {item.id && !viewOnly ? (
              <Icon
                onClick={() => {
                  setCurrentItem(item);
                  openModal();
                }}
                className="imageUploadsectionsp"
                src={mediaUrls?.refreshIcon}
              />
            ) : null}
            {!viewOnly && (
              <Link
                onClick={() => {
                  setCurrentItem(item);
                  openModal();
                }}
                className="uploadSection"
              >
                {item.id ? <span>{i18n.t('Update')}</span> : <span className="uploadText">{i18n.t('Upload')}</span>}
              </Link>
            )}
          </>
          {item.id || viewOnly ? null : <Label> {i18n.t(item?.type?.fullName)}</Label>}
          {item.id && (
            <>
              <Styled.UpdateWrapper>
                <Label className="details"> {i18n.t(item.type.fullName)}</Label>
                <Label className="uploadDetails">
                  {i18n.t('Uploaded')} {item.uploaded}{' '}
                </Label>
                {item.expiration_date ? (
                  <Label className="uploadDetails">
                    {i18n.t('Expiration')} {item.expiration_date}
                  </Label>
                ) : null}
              </Styled.UpdateWrapper>
              <Styled.ItemUrl>
                <Link
                  onClick={() => {
                    downloadDocument({
                      apiId: 'downloadReceipt',
                      data: item?.id,
                    });
                  }}
                  className="downloadImage"
                >
                  <>
                    <Icon
                      src={mediaUrls?.download}
                      onClick={() =>
                        downloadDocument({
                          apiId: 'downloadReceipt',
                          data: item?.id,
                        })
                      }
                    />
                    {item.name}
                  </>
                </Link>
              </Styled.ItemUrl>
              {!viewOnly && (
                <>
                  <Icon
                    src={mediaUrls?.deleteIcon}
                    onClick={() => {
                      setCurrentItem(item);
                      deleteDocument({
                        apiId: deleteApi,
                        data: { id: item.id },
                        config: {
                          userId: userId,
                          trailerIdPub: trailerIdPub,
                          vehicleIdPub: vehicleIdPub,
                          isEdit: isEdit,
                        },
                      });
                    }}
                    className="imageUploadsection"
                  />
                  <Icon
                    src={mediaUrls?.deleteIcon}
                    onClick={() => {
                      setCurrentItem(item);
                      deleteDocument({
                        apiId: deleteApi,
                        data: { id: item.id },
                        config: {
                          userId: userId,
                          trailerIdPub: trailerIdPub,
                          vehicleIdPub: vehicleIdPub,
                          isEdit: isEdit,
                        },
                      });
                    }}
                    className="imageUploadsectionsp"
                  />
                </>
              )}
            </>
          )}
        </li>
      )}
    </>
  );
};
